/* eslint-disable camelcase */
import { mapState } from 'vuex';

export default {
  data() {
    return {
      /**
       * variable for storing the timer
       */
      authInterval: undefined,
    };
  },
  computed: {
    /**
     * Vuex mappings
     */
    ...mapState('auth', ['token_expires_in']),
  },
  watch: {
    /**
     * Watch for any changes to token_expires_in, this is also to watch for when a user logs in
     * and token_expires_in is set
     */
    token_expires_in() {
      this.setAuthTimer();
    },
  },
  created() {
    /**
     * Start timer on application created
     */
    this.setAuthTimer();
    this.$root.$on('auth:login', () => {
      this.setAuthTimer();
    });
  },
  destroyed() {
    this.$root.$off('auth:login');
  },
  methods: {
    /**
     * Method to clear the existing timer if it exists
     */
    clearAuthTimer() {
      if (this.authInterval) {
        this.$log.info('clearing auth timer');
        clearInterval(this.authInterval);
        this.authInterval = null;
      }
    },
    /**
     * Method to set the auth timer
     */
    setAuthTimer() {
      const { token_expires_in } = this;
      const interval = (token_expires_in / 4) * 1000;
      if (!Number.isNaN(interval)) {
        this.$log.info(`setting auth timer ${interval}ms`);
        this.clearAuthTimer();
        this.authInterval = setInterval(async () => {
          this.$log.debug('trigger timer');
          await this.$store.dispatch('auth/REFRESH_auth');
        }, interval);
      } else {
        this.$log.info('ignoring invalid interval for timer');
      }
    },
  },
};
